import {circleSwirlie} from 'circleSwirlie.js';
import {frontpageFix} from 'frontpageFix.js'

function ready(fn) {
    if( document.readyState !== 'loading' ) {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

ready(function() {
    
    let html = document.querySelector('html');
    html.classList.add('js');
    html.classList.remove('no-js');
    
    const target = document.querySelector('#circles');
    if (target){
        frontpageFix();
        circleSwirlie(target);
    }
    
    // Play with this value to change the speed
    let tickerSpeed = 2;

    let flickity = null;
    let isPaused = false;
    const slideshowEl = document.querySelector('.affiliation-box');


    //
    //   Functions
    //
    //////////////////////////////////////////////////////////////////////

    const update = () => {
    if (isPaused) return;
    if (flickity.slides) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
    }
    window.requestAnimationFrame(update);
    };

    const pause = () => {
    isPaused = true;
    };

    const play = () => {
    if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
    }
    };

    let images = document.querySelector('.affiliation-box');
    let imgLoader = new imagesLoaded( '.affiliation-box', { background: "true" } );

    imgLoader.on( 'always', function( instance ) {
        console.log( 'ALWAYS - all images have been loaded.' );
        images.classList.add('js-images-loaded');
        for ( var i = 0, len = imgLoader.images.length; i < len; i++ ) {
            var image = imgLoader.images[i];
            if( !image.isLoaded ) {
                image.img.parentElement.parentElement.remove();
            }
        }

        //
        //   Create Flickity
        //
        //////////////////////////////////////////////////////////////////////

        flickity = new Flickity(slideshowEl, {
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
            wrapAround: true,
            freeScroll: true,
            });
            flickity.x = 0;
        
        
            //
            //   Add Event Listeners
            //
            //////////////////////////////////////////////////////////////////////
        
            slideshowEl.addEventListener('mouseenter', pause, false);
            slideshowEl.addEventListener('focusin', pause, false);
            slideshowEl.addEventListener('mouseleave', play, false);
            slideshowEl.addEventListener('focusout', play, false);
        
            flickity.on('dragStart', () => {
            isPaused = true;
            });
        
        
            //
            //   Start Ticker
            //
            //////////////////////////////////////////////////////////////////////
        
            update();
        
    });

});
